<template>
    <div class="dashboard-home container">
        <div class="columns">
            <div class="column">
                <progressive-background class="notification tertiary user-info"
                                        :src="hiresDashboardImagePath"
                                        :placeholder="thumbnailDashboardImagePath"
                                        no-ratio>
                    <div slot="content">
                        <div class="columns">
                            <div class="column is-half-desktop user-column">
                                <div class="is-size-1 is-size-3-touch has-text-weight-bold">
                                    {{ $t('dashboard.welcome.greeting', { user: displayName }) }}
                                </div>
                                <p class="is-size-3 is-size-5-touch">
                                    {{ $t('dashboard.welcome.message') }}
                                </p>
                                <p class="is-size-2 is-size-4-touch">
                                    <text-placeholder :text="account.name" />
                                </p>
                                <p v-if="(accountCount > 1)"
                                   class="is-size-4 is-size-5-touch">
                                    <router-link :to="{ name: 'Accounts' }"
                                                 class="account-link">
                                        {{ $t('common.switch_account') }}
                                    </router-link>
                                </p>
                            </div>
                            <div class="column justify-column is-hidden-touch">
                                <img v-if="$store.state.logos.length"
                                     class="brand-logo image"
                                     :src="$store.state.logos[1]">
                                <img v-else
                                     src="../assets/white-logo.png"
                                     class="web-logo image"
                                     alt="webdotcom">
                            </div>
                        </div>
                    </div>
                </progressive-background>
            </div>
        </div>
        <!-- row 2 -->
        <div class="columns">
            <!-- GETTING STARTED PANEL -->
            <div v-if="$store.state.showGettingStarted && getTenantConfig('showHowTo')"
                 class="column">
                <dashboard-panel id="dashboard_panel_show_how_to"
                                 :has-service="true"
                                 title="Getting Started"
                                 background-icon="play-circle"
                                 :hide-service="false">
                    <div class="content relative-top">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="blank"
                           @click.prevent="toggleSlider()">
                            {{ $t('dashboard.start_link') }}
                        </a>
                    </div>
                </dashboard-panel>
            </div>
            <!-- GETTING STARTED PANEL ENDS -->
            <!-- TEMPLATE PICKER  PANEL -->
            <!-- <div
      v-if="panelShowLogic('templatePicker')"
      class="column"
    >
      <dashboard-panel
        :has-service="true"
        :title="$t('templatepicker.title.tag')"
        background-icon="images"
        :hide-service="false"
        id="dashboard_panel_template_picker"
      >
        <div class="content relative-top">
          <font-awesome-icon
            icon="chevron-right"
            class="link-icon"
          />
          <router-link
            :to="{ name: 'TemplatePicker' }"
            class="account-link"
          >
          {{ $t('templatepicker.subtitle.tag') }}
          </router-link>
        </div>
      </dashboard-panel>
    </div> -->
            <!-- TEMPLATE PICKER PANEL ENDS -->
            <!-- PROFILE PANEL -->
            <div v-if="panelShowLogic('businessProfile')"
                 class="column">
                <dashboard-panel id="dashboard_panel_business_profile"
                                 :has-service="true"
                                 :title="$t('businessprofile.title.tag')"
                                 background-icon="address-card"
                                 :hide-service="false">
                    <div class="content relative-top">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <router-link :to="{ name: 'BusinessProfileForm' }"
                                     class="account-link">
                            {{ $t('businessprofile.subtitle.tag') }}
                        </router-link>
                        <font-awesome-icon icon="bullseye"
                                           class="link-icon pulse" />
                        <!-- <br>
                <font-awesome-icon
                  icon="chevron-right"
                  class="link-icon"
                />
                <a
                  href="#"
                  target="_blank"
                  @click.prevent="$store.state.skipBusinessProfile = true"
                >
                  {{ $t('common.tag.skip') }}
                </a> -->
                    </div>
                </dashboard-panel>
            </div>
            <!-- PROFILE PANEL  -->

            <div v-if="!serviceEnabled('yolawebsite') && !serviceEnabled('sitepluswebsite') && serviceEnabled('website')"
                 class="column">
                <!-- WEBSITE DASHBOARD PANEL -->
                <dashboard-panel id="dashboard_panel_website"
                                 :has-service="serviceEnabled('website')"
                                 :title="$t('dashboard.website.title')"
                                 :subtitle="websiteDetails && websiteDetails.domainName"
                                 :no-service-title="$t('dashboard.website.no_site')"
                                 background-icon="globe"
                                 :hide-service="getTenantConfig('hideService','website') || !serviceStatusAllowed(websiteDetails)">
                    <div class="website-btn">
                        <font-awesome-icon v-show="(websiteDetails && websiteDetails.domainName)?true:false"
                                           icon="chevron-right"
                                           class="link-icon" />
                        <a v-show="(websiteDetails && websiteDetails.domainName)?true:false"
                           :href="`${websiteDetails && websiteDetails.url}`"
                           target="_blank">
                            {{ $t('dashboard.website.preview_link_text') }}
                        </a>
                        <br v-show="(websiteDetails && websiteDetails.domainName)?true:false">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="_blank"
                           @click.prevent="goToGeneratedLink(getWebsiteLink, $event)">
                            {{ $t('dashboard.website.edit') }}
                        </a>
                        <br>
                        <span v-if="websiteDetails && getTenantConfig('showWebsiteByDIFM', websiteDetails.isDifm)">
                            <font-awesome-icon icon="chevron-right"
                                               class="link-icon" />
                            <router-link :to="{ name: 'ModFormPage' }">
                                {{ $t('dashboard.website.mods') }}
                            </router-link>
                        </span>
                    </div>
                </dashboard-panel>
            </div>
            <!-- WEBSITE DASHBOARD PANEL ENDS -->
            <!-- YOLA WEBSITE DASHBOARD PANEL -->
            <div v-if="panelShowLogic('yolawebsite')"
                 class="column">
                <dashboard-panel id="dashboard_panel_yola_website"
                                 :has-service="serviceEnabled('yolawebsite')"
                                 :title="$t('dashboard.website.title')"
                                 :subtitle="(yolaWebsiteDetails && yolaWebsiteDetails.serviceState === 'Fulfilled')?yolaWebsiteDetails.domainName:''"
                                 :no-service-title="$t('dashboard.website.no_site')"
                                 background-icon="globe"
                                 :hide-service="getTenantConfig('hideService','yolawebsite') || !serviceStatusAllowed(yolaWebsiteDetails)">
                    <div v-if="(yolaWebsiteDetails && yolaWebsiteDetails.serviceState === 'Fulfilled')?true:false"
                         class="website-btn">
                        <font-awesome-icon v-show="(yolaWebsiteDetails && yolaWebsiteDetails.domainName)?true:false"
                                           icon="chevron-right"
                                           class="link-icon" />
                        <a v-show="(yolaWebsiteDetails && yolaWebsiteDetails.domainName)?true:false"
                           :href="`${yolaWebsiteDetails && yolaWebsiteDetails.url}`"
                           target="_blank">
                            {{ $t('dashboard.website.preview_link_text') }}
                        </a>
                        <br v-show="(yolaWebsiteDetails && yolaWebsiteDetails.domainName)?true:false">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="_blank"
                           @click.prevent="goToYolaGeneratedLink(getYolaWebsiteEditLink, $event)">
                            {{ $t('dashboard.website.edit') }}
                        </a>
                    </div>
                    <div v-else-if="(hasPendingDomain || hasPendingDomainSelection)"
                         class="content relative-top">
                        {{ $t('dashboard.flockmail_pending') }}
                    </div>
                    <div v-else
                         class="content relative-top">
                        {{ $t('common.loading_message') }}
                    </div>
                </dashboard-panel>
                <!-- YOLA WEBSITE DASHBOARD PANEL ENDS -->
            </div>

            <div v-if="panelShowLogic('sitepluswebsite')"
                 class="column">
                <!-- SITEPLUS WEBSITE DASHBOARD PANEL -->
                <dashboard-panel id="dashboard_panel_siteplus_website"
                                 :has-service="serviceEnabled('sitepluswebsite')"
                                 :title="$t('dashboard.website.title')"
                                 :subtitle="siteplusWebsiteDetails && siteplusWebsiteDetails.domainName"
                                 :no-service-title="$t('dashboard.website.no_site')"
                                 background-icon="globe"
                                 :hide-service="getTenantConfig('hideService','sitepluswebsite') || !serviceStatusAllowed(siteplusWebsiteDetails)">
                    <p v-show="ecommerceMsg"
                       class="">
                        It may take a few minutes to build your online store. Please wait...
                    </p>
                    <div v-if="siteplusWebsiteDetails"
                         class="website-btn columns">
                        <!-- SitePlus template picker link -->
                        <div class="column">
                            <font-awesome-icon v-show="panelShowLogic('templatePicker')"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <router-link v-show="panelShowLogic('templatePicker')"
                                         :to="{ name: 'TemplatePicker' }"
                                         class="account-link">
                                {{ $t('templatepicker.subtitle.tag') }}
                            </router-link>
                            <font-awesome-icon v-show="panelShowLogic('templatePicker')"
                                               icon="bullseye"
                                               class="link-icon pulse" />
                            <!-- SitePlus template picker link ends -->
                            <br v-show="panelShowLogic('templatePicker')">
                            <font-awesome-icon v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName && siteplusWebsiteDetails.hasTemplate)?true:false"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName && siteplusWebsiteDetails.hasTemplate)?true:false"
                               :href="`${siteplusWebsiteDetails && siteplusWebsiteDetails.url}`"
                               target="_blank">
                                {{ $t('dashboard.website.preview_link_text') }}
                            </a>
                            <!-- SitePlus preview website link end -->
                            <br v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName && siteplusWebsiteDetails.hasTemplate)?true:false">
                            <!-- SitePlus website edit link -->
                            <font-awesome-icon v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName && siteplusWebsiteDetails.hasTemplate)?true:false"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName && siteplusWebsiteDetails.hasTemplate)?true:false"
                               href="#"
                               target="_blank"
                               @click.prevent="goToSiteplusGeneratedLink(getSiteplusWebsiteEditLink, $event)">
                                {{ $t('dashboard.website.edit') }}
                            </a>
                            <!-- SitePlus website edit link end -->
                            <br v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName && siteplusWebsiteDetails.hasTemplate)?true:false">
                            <!-- SitePlus analytics link start -->
                            <font-awesome-icon v-show="(siteplusWebsiteDetails.hasTemplate)"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-show="(siteplusWebsiteDetails.hasTemplate)"
                               href="#"
                               @click.prevent="goToSiteplusGeneratedLink(getSiteplusWebsiteAnalitycsLink, $event)">
                                {{ $t('dashboard.view_analitycs.label') }}
                            </a>
                            <!-- SitePlus analytics link end -->
                            <br v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.hasTemplate)?true:false">
                            <!-- SitePlus configure your domain link -->
                            <font-awesome-icon icon="chevron-right"
                                               class="link-icon" />
                            <router-link :to="{ name: 'ConfigureDomain' }"
                                         class="account-link">
                                Configure your domain
                                <!-- {{ $t('templatepicker.subtitle.tag') }} -->
                            </router-link>
                            <!-- SitePlus configure your domain link ends -->
                            <br>
                            <!-- SitePlus preview website link -->
                        </div>
                        <div class="column">
                            <!-- SitePlus ecommerce shop start -->
                            <font-awesome-icon v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanAvailable && !siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanAvailable && !siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false"
                               @click="enableShop">
                                {{ activeShopLoading ? "Activating..." : 'Activate Online Store' }}
                            </a>
                            <font-awesome-icon v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false"
                               href="#"
                               target="_blank"
                               @click.prevent="goToSiteplusGeneratedLink(getSiteplusWebsiteEditLink, $event)">
                                Manage Online Store <!--{{ $t('dashboard.manage_shop') }} -->
                            </a>
                            <!-- SitePlus ecommerce shop End -->
                            <br v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanAvailable && siteplusWebsiteDetails.hasTemplate)?true:false">
                            <font-awesome-icon v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false"
                               @click.prevent="toggleEcommSlider()">
                                Online Store Guide <!-- {{ $t('dashboard.start_link') }} -->
                            </a>
                            <font-awesome-icon v-show="showHighlightIcons"
                                               icon="bullseye"
                                               class="link-icon pulse" />
                            <br v-if="(siteplusWebsiteDetails && siteplusWebsiteDetails.isOptionalPlanEnabled && siteplusWebsiteDetails.hasTemplate)?true:false">
                            <!-- SitePlus website helper link start -->
                            <font-awesome-icon v-show="getTenantConfig('showHelpLink','sitepluswebsite')"
                                               icon="chevron-right"
                                               class="link-icon" />
                            <a v-show="getTenantConfig('showHelpLink','sitepluswebsite')"
                               :href="` https://websitebuildersupport.web.com`"
                               target="_blank">
                                Website builder help
                            </a>
                            <!-- SitePlus website helper link end -->
                        </div>
                    </div>
                    <!-- <div
              v-else-if="ecommerceMsg"
              class="content relative-top notification"
            >
              We are currently building your shop, please come back later
            </div> -->
                    <div v-else
                         class="content relative-top">
                        {{ $t('common.loading_message') }}
                    </div>
                </dashboard-panel>
            </div>
            <!-- SITEPLUS WEBSITE DASHBOARD PANEL ENDS -->
            <!-- SITEPLUS DOMAIN DETAILS DASHBOARD PANEL -->
            <div v-show="panelShowLogic('domaindetails')"
                 class="column">
                <dashboard-panel id="dashboard_panel_domain_registration"
                                 :has-service="(hasRegisteredDomain)"
                                 :title="$t('dashboard.domains.title')"
                                 :no-service-title="$t('dashboard.domains.no_service')"
                                 background-icon="globe"
                                 :hide-service="getTenantConfig('hideService','domainregistration') || !serviceStatusAllowed(domainData)">
                    <div class="website-btn">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <router-link :to="{ name: 'MyDomains' }"
                                     class="account-link">
                            {{ $t('sidebar.domains_overview') }}
                        </router-link>
                    </div>
                    <div v-show="hasRegisteredDomain"
                         class="website-btn">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a :href="dnsSsoUrl" class="account-link" target="_blank"> Manage DNS</a>
                    </div>
                </dashboard-panel>
            </div>
            <!-- SITEPLUS DOMAIN DETAILS DASHBOARD PANEL ENDS -->
            <!-- DOMAINS DASHBOARD PANEL -->
            <div v-if="panelShowLogic('domainregistration')"
                 class="column">
                <dashboard-panel id="dashboard_panel_domain_registration"
                                 :has-service="(hasPendingDomain || hasRegisteredDomain || hasPendingDomainSelection)"
                                 :title="$t('dashboard.domains.title')"
                                 :subtitle="domainData && domainData.domainName"
                                 :no-service-title="$t('dashboard.domains.no_service')"
                                 background-icon="globe"
                                 :hide-service="getTenantConfig('hideService','domainregistration') || !serviceStatusAllowed(domainData)">
                    <div v-show="hasPendingDomainSelection || hasPendingDomain"
                         class="website-btn">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <router-link :to="{ name: 'DomainRegistration' }"
                                     class="account-link">
                            <span v-show="hasPendingDomainSelection">
                                {{ $t('sidebar.domains.need_to_register') }}
                            </span>
                            <span v-show="hasPendingDomain">
                                {{ $t('sidebar.domains.pending_registration') }}
                            </span>
                        </router-link>
                    </div>
                    <div v-show="hasRegisteredDomain"
                         class="website-btn">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <router-link :to="{ name: 'MyDomains' }"
                                     class="account-link">
                            {{ $t('sidebar.domains_overview') }}
                        </router-link>
                    </div>
                    <div v-show="hasRegisteredDomain"
                         class="website-btn">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a :href="dnsSsoUrl" class="account-link" target="_blank"> Manage DNS</a>
                    </div>
                </dashboard-panel>
            </div>

            <!-- **************** DOMAINS DASHBOARD PANEL ENDS ************************** -->
            <div v-if="serviceEnabled('email') || serviceEnabled('flockemail')"
                 class="column">
                <dashboard-panel v-if="!serviceEnabled('flockemail')"
                                 :has-service="serviceEnabled('email')"
                                 :title="$t('dashboard.email.title')"
                                 :subtitle="emailService && emailService.emailAddress"
                                 :no-service-title="$t('dashboard.email.no_email')"
                                 background-icon="at"
                                 :hide-service="getTenantConfig('hideService','email') || !serviceStatusAllowed(emailService)"
                                 id="dashboard_panel_email">
                    <div class="content relative-top">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a v-if="getTenantConfig('showLinks')"
                           target="_blank">
                            {{ $t('dashboard.email.view_link_text') }}
                        </a>
                        <a v-else
                           href="#"
                           @click.prevent="goToGeneratedLink(getEmailLink, $event)">
                            {{ $t('dashboard.email.view_link_text') }}
                        </a>
                    </div>
                </dashboard-panel>
                <!-- ***************** EMAIL DASHBOARD PANEL ENDS ********************************** -->
                <!-- ***************** FLOCK EMAIL DASHBOARD PANEL ********************************* -->
                <dashboard-panel v-else
                                 id="dashboard_panel_flockemail"
                                 :has-service="serviceEnabled('flockemail')"
                                 :title="$t('dashboard.email.title')"
                                 :subtitle="flockEmailService && flockEmailService.domainName"
                                 :no-service-title="$t('dashboard.email.no_email')"
                                 background-icon="at"
                                 :hide-service="getTenantConfig('hideService','flockemail') || !serviceStatusAllowed(flockEmailService)">
                    <div v-if="flockEmailService && flockEmailService.domainName"
                         class="content relative-top">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="_blank"
                           @click.prevent="goToFlockEmailGeneratedLink(getFlockEmailLink, $event)">
                            {{ $t('dashboard.email.view_link_text') }}
                        </a>
                    </div>
                    <div v-else
                         class="content relative-top">
                        {{ $t('dashboard.flockmail_pending') }}
                    </div>
                </dashboard-panel>
                <!-- ******************** FLOCK EMAIL DASHBOARD PANEL ENDS **************************** -->
            </div>

            <!-- ***************** TOTAL CHATBOTS DASHBOARD PANEL ********************************* -->
            <div v-if="serviceEnabled('totalchatbotswebchat')"
                 class="column">
                <dashboard-panel id="dashboard_panel_totalchatbot"
                                 :has-service="serviceEnabled('totalchatbotswebchat')"
                                 :title="$t('dashboard.totalchat.title')"
                                 :subtitle="$t('dashboard.totalchat.subtitle')"
                                 background-icon="comment"
                                 :hide-service="getTenantConfig('hideService','totalchatbotswebchat')">
                    <div
                         class="content relative-top">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="_blank"
                           @click.prevent="goToGeneratedLink(getTotalChatBotLink, $event)">
                            {{ $t('dashboard.totalchat.link_text') }}
                        </a>
                    </div>
                </dashboard-panel>
            </div>
            <!-- ***************** TOTAL CHATBOTS DASHBOARD PANEL ENDS ********************************* -->

            <!-- **********************    REPORTING DASHBOARD PANEL ******************************** -->
            <div v-if="(serviceEnabled('scorecard') || serviceEnabled('payPerClick'))"
                 class="column">
                <dashboard-panel id="dashboard_panel_scorecard"
                                 :has-service="(serviceEnabled('scorecard') || serviceEnabled('payPerClick'))"
                                 :title="$t('dashboard.report.title')"
                                 :subtitle="$t('dashboard.report.subtitle')"
                                 :no-service-title="$t('dashboard.report.no_report')"
                                 background-icon="chart-bar"
                                 :hide-service="getTenantConfig('hideService','scorecard') || getTenantConfig('hideService','seo')">
                    <div v-if="!!services.scorecard">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="_blank"
                           @click.prevent="goToGeneratedLink(getScorecardLink, $event)">
                            {{ $t('dashboard.report.view_scorecard') }}
                        </a>
                        <br>
                    </div>
                    <div v-if="!!services.payPerClick">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <a href="#"
                           target="_blank"
                           @click.prevent="goToGeneratedLink(getPPCLink, $event)">
                            {{ $t('dashboard.report.view_ppc') }}
                        </a>
                        <br>
                    </div>
                    <div v-if="!!services.seo">
                        <font-awesome-icon icon="chevron-right"
                                           class="link-icon" />
                        <router-link :to="`/seoperformance/${services.seo}`">
                            {{ $t('dashboard.report.view_seo') }}
                        </router-link>
                        <br>
                    </div>
                </dashboard-panel>
            </div>
            <!-- ******************** REPORTING DASHBOARD PANEL ENDS ***************************** -->
            <!-- ********************    WEBSITE BUILDER HELP ************************************ -->
            <!-- <div
      v-if="getTenantConfig('infoPanel3') && serviceEnabled('sitepluswebsite')"
      class="column"
    >
      <dashboard-panel
        :has-service="getTenantConfig('infoPanel3') && serviceEnabled('sitepluswebsite')"
        :title="$t('dashboard.website_builder_help.title')"
        subtitle=""
        background-icon="info-circle"
        :hide-service="false"
        id="dashboard_panel_info_panel_3"
      >
        <div
          v-if="getTenantConfig('showHelpLink','sitepluswebsite')"
          class="website-btn"
        >
          <font-awesome-icon
            v-show="true"
            icon="chevron-right"
            class="link-icon"
          />
          <a
            v-show="true"
            :href="` https://websitebuildersupport.web.com`"
            target="_blank"
          >
            {{ $t('dashboard.knowledgebase.label') }}
          </a>
        </div>
      </dashboard-panel>
    </div> -->
            <!-- WEBSITE BUILDER HELP ENDS -->
        </div>

            <!-- row 3 -->
            <div class="columns">
                <!-- INFO 1 DASHBOARD PANEL -->
                <div v-if="getTenantConfig('infoPanel1')"
                     class="column">
                    <dashboard-panel id="dashboard_panel_info_panel_1"
                                     :has-service="getTenantConfig('infoPanel1')"
                                     :title="$t('dashboard.acronis.title')"
                                     :subtitle="$t('dashboard.acronis.subtitle')"
                                     background-icon="info-circle"
                                     :hide-service="false">
                        <acronis-panel />
                    </dashboard-panel>
                </div>
                <!-- INFO 1 DASHBOARD PANEL ENDS -->
                <!-- INFO 2 DASHBOARD PANEL -->
                <div v-if="getTenantConfig('infoPanel2')"
                     class="column">
                    <dashboard-panel id="dashboard_panel_info_panel_2"
                                     :has-service="getTenantConfig('infoPanel2')"
                                     :title="$t('dashboard.microsoft365.title')"
                                     :subtitle="$t('dashboard.microsoft365.subtitle')"
                                     background-icon="info-circle"
                                     :hide-service="false">
                        <microsoft-365-panel />
                    </dashboard-panel>
                </div>
                <!-- INFO 2 DASHBOARD PANEL ENDS -->
            </div>

            <carousel-modal :show-slider="this.$store.state.showSliderBT"
                            @close="toggleSlider" />
            <ecomm-modal :show-slider="this.$store.state.showSliderEcomm"
                         @close="toggleEcommSlider" />
        </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import generatedFlockUrlMixin from '@/mixins/flock-generated-urls'
    import generatedUrlsMixin from '@/mixins/generated-urls'
    import generatedYolaUrlMixin from '@/mixins/yola-generated-urls'
    import TextPlaceholder from '@/components/Shared/TextPlaceholder'
    import DashboardPanel from '@/components/Shared/DashboardPanel'
    import domainOverviewMixin from '@/mixins/domain-overview'
    import tenantConfigwMixin from '@/mixins/tenant-config'
    import generatedSiteplusUrlMixin from '@/mixins/siteplus-generated-urls'
    import carouselModal from '@/components/modals/CarouselModal'
    import ecommModal from '@/components/modals/EcommModal'
    import businessProfileMixin from '@/mixins/business-profile'
    import AcronisPanel from '@/components/Shared/DashboardContent/AcronisPanel'
    import Microsoft365Panel from '@/components/Shared/DashboardContent/Microsoft365Panel'

    export default {
        name: 'Dashboard',
        components: {
            TextPlaceholder,
            DashboardPanel,
            carouselModal,
            AcronisPanel,
            Microsoft365Panel,
            ecommModal
        },
        mixins: [
            generatedUrlsMixin,
            domainOverviewMixin,
            generatedYolaUrlMixin,
            tenantConfigwMixin,
            generatedFlockUrlMixin,
            generatedSiteplusUrlMixin,
            businessProfileMixin
        ],
        data() {
            return {
                url: null,
                newtab: null,
                activeShopLoading: false,
                ecommerceMsg: false,
                showHighlightIcons: false
            }
        },
        computed: {
            ...mapState(['account', 'user', 'showSliderBT', 'showSliderEcomm', 'skipBusinessProfile', 'showAssignServices']),
            ...mapGetters(['username', 'clientCredentials', 'serviceEnabled', 'brandConfigValue', 'getUseLocalStyle', 'accountCount', 'displayName']),
            ...mapGetters('domainService', ['hasPendingDomain', 'hasRegisteredDomain', 'hasPendingDomainSelection']),
            ...mapGetters('websiteService', ['isDifm']),

            thumbnailDashboardImagePath() {
                return require('../assets/thumbnails/thumb_dashboard.jpg')
            },

            hiresDashboardImagePath() {
                return require('../assets/dashboard_greyscale.jpg')
            },

            thumbnailSEOBackgroundImagePath() {
                return require('../assets/thumbnails/thumb_seo_background.jpg')
            },

            hiresSEOBackgroundImagePath() {
                return require('../assets/seo_background_greyscale.jpg')
            },

            phoneHelp() {
                if (this.getUseLocalStyle()) {
                    return this.$t('phone_number.help')
                }
                return this.brandConfigValue('phone_number', 'help')
            },

            emailHelp() {
                if (this.getUseLocalStyle()) {
                    return this.$t('email.help')
                }
                return this.brandConfigValue('email', 'help')
            },

            dnsSsoUrl() {
                var hostname = this.hostname
                var label = hostname.substr(0, hostname.indexOf('.'))
                var domain = hostname.substr(hostname.indexOf('.'))

                return "https://" + label + "-alt" + domain + "/aws-create-session?idtoken=" + this.$store.getters.getUserJWT
            }
        },
        watch: {
            siteplusWebsiteDetails: {
                handler(obj) {
                    if (obj != null) {
                        // shop loading
                        if (obj.serviceState === 'UpdatingSubscription') {
                            this.activeShopLoading = true
                        } else if (this.activeShopLoading === true && obj.serviceState === 'Fulfilled') {
                            this.activeShopLoading = false
                            this.ecommerceMsg = false
                            this.$store.state.showSliderEcomm = true
                        }
                        // slider BT open
                        if (this.getTenantConfig('showHowTo') &&
                            this.serviceEnabled('sitepluswebsite') &&
                            obj.serviceState !== 'Fulfilled' &&
                            obj.serviceState !== 'UpdatingSubscription') {
                            this.$store.state.showGettingStarted = true
                            if (this.$store.state.showSliderBT === null) {
                                this.$store.state.showSliderBT = true
                            }
                        }

                        // slider ECOMM open
                        if (this.getTenantConfig('showEcommTour') &&
                            this.serviceEnabled('sitepluswebsite') &&
                            this.siteplusWebsiteDetails.isOptionalPlanEnabled === 'true') {
                            this.$store.state.showSliderEcomm = true
                            if (this.$store.state.showSliderEcomm === null) {
                                this.$store.state.showSliderEcomm = true
                            }
                        }
                    }
                }
            }
        },
        methods: {
            serviceProperty(service, field) {
                if (typeof service !== 'undefined' && Object.prototype.hasOwnProperty.call(service, field)) {
                    return service[field]
                }
                return false
            },

            serviceStatusAllowed(service) {
                if (typeof service !== 'undefined' && Object.prototype.hasOwnProperty.call(service, 'status') && service.status !== '') {
                    return ['Active', 'Suspended'].includes(service.status)
                }
                return true
            },

            toggleSlider() {
                if (this.getTenantConfig('showHowTo')) {
                    if (this.$store.state.showSliderBT != null) {
                        this.$store.state.showSliderBT = !this.$store.state.showSliderBT
                    } else {
                        this.$store.state.showSliderBT = true
                    }
                } else {
                    this.$store.state.showSliderBT = false
                }
            },

            toggleEcommSlider() {
                if (this.getTenantConfig('showEcommTour')) {
                    if (this.$store.state.showSliderEcomm != null) {
                        this.$store.state.showSliderEcomm = !this.$store.state.showSliderEcomm
                    } else {
                        this.$store.state.showSliderEcomm = true
                    }
                } else {
                    this.$store.state.showSliderEcomm = false
                }
            },

            async enableShop() {
                this.activeShopLoading = true
                var result = await this.activateShop(this.sitePlusWebsiteId, true)
                if (result !== false) {
                    this.ecommerceMsg = true
                    await this.$apollo.queries.siteplusWebsiteDetails.loading
                } else {
                    this.activeShopLoading = false
                    this.ecommerceMsg = true
                }
            },

            panelShowLogic(panel) {
                switch (this.getTenantEnv()) {
                    case 'FCR_PROD':
                    case 'FCR_QA':
                        return this.panelLogicFCR(panel)

                    case '1800_PROD':
                    case '1800_QA':
                        return this.panelLogic1800(panel)

                    case 'BT_PROD':
                    case 'BT_QA':
                        return this.panelLogicBT(panel)

                    case 'TIDE_PROD':
                    case 'TIDE_QA':
                        return this.panelLogicTIDE(panel)

                    default:
                        return this.panelLogicWEB(panel)
                }
            },

            panelLogicBT(panel) {
                switch (panel) {
                    case 'domainregistration':
                        if (!this.getTenantConfig('hideService', 'domainregistration') &&
                            !this.serviceStatusAllowed(this.siteplusWebsiteDetails) && this.profileWasUpdated) {
                            return true
                        }

                        break

                    case 'domaindetails':
                        if (!this.getTenantConfig('hideService', 'domainregistration') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails) &&
                            this.hasRegisteredDomain) {
                            return true
                        }

                        break

                    case 'businessProfile':

                        if (!this.getTenantConfig('hideService', 'businessProfile') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails) &&
                            this.hasPendingDomainSelection &&
                            !this.$store.state.skipBusinessProfile &&
                            !this.profileWasUpdated) {
                            return true
                        }

                        break

                    case 'templatePicker':
                        if (!this.getTenantConfig('hideService', 'templatePicker') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails) && this.siteplusWebsiteDetails.domainName &&
                            this.serviceProperty(this.siteplusWebsiteDetails, 'serviceState') &&
                            this.serviceProperty(this.siteplusWebsiteDetails, 'serviceState') !== 'UpdatingSubscription' &&
                            !this.serviceProperty(this.siteplusWebsiteDetails, 'hasTemplate')) {
                            return true
                        }

                        break

                    case 'website':
                        if (!this.getTenantConfig('hideService', 'website') &&
                            !this.serviceEnabled('yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite')) {
                            return true
                        }

                        break

                    case 'sitepluswebsite':
                        if (!this.getTenantConfig('hideService', 'sitepluswebsite') &&
                            !this.serviceEnabled('yolawebsite') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails) &&
                            (this.profileWasUpdated || this.$store.state.skipBusinessProfile)) {
                            return true
                        }

                        break

                    case 'yolawebsite':
                        if (!this.getTenantConfig('hideService', 'yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite') &&
                            this.serviceStatusAllowed(this.yolawebsite)) {
                            return true
                        }

                        break
                }

                return false
            },

            panelLogicFCR(panel) {
                switch (panel) {
                    case 'domainregistration':
                        if (!this.getTenantConfig('hideService', 'domainregistration') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'businessProfile':
                        if (!this.getTenantConfig('hideService', 'businessProfile') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'templatePicker':
                        if (!this.getTenantConfig('hideService', 'templatePicker') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'website':
                        if (!this.getTenantConfig('hideService', 'website') &&
                            !this.serviceEnabled('yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite')) {
                            return true
                        }

                        break

                    case 'sitepluswebsite':
                        if (!this.getTenantConfig('hideService', 'sitepluswebsite') &&
                            !this.serviceEnabled('yolawebsite') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'yolawebsite':
                        if (!this.getTenantConfig('hideService', 'yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite') &&
                            this.serviceStatusAllowed(this.yolawebsite)) {
                            return true
                        }

                        break
                }

                return false
            },

            panelLogic1800(panel) {
                switch (panel) {
                    case 'domainregistration':
                        if (!this.getTenantConfig('hideService', 'domainregistration') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }
                        break

                    case 'businessProfile':
                        if (!this.getTenantConfig('hideService', 'businessProfile') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'templatePicker':
                        if (!this.getTenantConfig('hideService', 'templatePicker') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'website':
                        if (!this.getTenantConfig('hideService', 'website') &&
                            !this.serviceEnabled('yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite')) {
                            return true
                        }

                        break

                    case 'sitepluswebsite':
                        if (!this.getTenantConfig('hideService', 'sitepluswebsite') &&
                            !this.serviceEnabled('yolawebsite') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'yolawebsite':
                        if (!this.getTenantConfig('hideService', 'yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite') &&
                            this.serviceStatusAllowed(this.yolawebsite)) {
                            return true
                        }

                        break
                }

                return false
            },

            panelLogicTIDE(panel) {
                switch (panel) {
                    case 'domainregistration':
                        if (!this.getTenantConfig('hideService', 'domainregistration') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'businessProfile':
                        if (!this.getTenantConfig('hideService', 'businessProfile') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'templatePicker':
                        if (!this.getTenantConfig('hideService', 'templatePicker') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'website':
                        if (!this.getTenantConfig('hideService', 'website') &&
                            !this.serviceEnabled('yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite')) {
                            return true
                        }

                        break

                    case 'sitepluswebsite':
                        if (!this.getTenantConfig('hideService', 'sitepluswebsite') &&
                            !this.serviceEnabled('yolawebsite') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }

                        break

                    case 'yolawebsite':
                        if (!this.getTenantConfig('hideService', 'yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite') &&
                            this.serviceStatusAllowed(this.yolawebsite)) {
                            return true
                        }

                        break
                }

                return false
            },

            panelLogicWEB(panel) {
                switch (panel) {
                    case 'domainregistration':
                        if (!this.getTenantConfig('hideService', 'domainregistration') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }
                        break

                    case 'businessProfile':
                        if (!this.getTenantConfig('hideService', 'businessProfile') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }
                        break

                    case 'templatePicker':
                        if (!this.getTenantConfig('hideService', 'templatePicker') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }
                        break

                    case 'website':
                        if (!this.getTenantConfig('hideService', 'website') &&
                            !this.serviceEnabled('yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite')) {
                            return true
                        }

                        break

                    case 'sitepluswebsite':
                        if (!this.getTenantConfig('hideService', 'sitepluswebsite') &&
                            !this.serviceEnabled('yolawebsite') &&
                            this.serviceStatusAllowed(this.siteplusWebsiteDetails)) {
                            return true
                        }
                        break

                    case 'yolawebsite':
                        if (!this.getTenantConfig('hideService', 'yolawebsite') &&
                            !this.serviceEnabled('sitepluswebsite') &&
                            this.serviceStatusAllowed(this.yolawebsite)) {
                            return true
                        }
                        break
                }
                return false
            }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../sass/_variables.scss';

    .brand-logo, .web-logo {
        max-width: 350px;
        max-height: 180px;

        @media(max-width: 768px) {
            max-width: 150px;
        }
    }

    .justify-column {
        display: flex;
        justify-content: center;
        align-items: center;

        @media(max-width: 768px) {
            justify-content: left;
        }
    }

    .user-column {
        padding-left: 20px;

        @media(max-width: 768px) {
            padding-left: 10px;
        }
    }

    .is-ancestor {
        margin-bottom: 0.75rem !important;
    }

    .placeholder {
        min-height: 150px;
        background: var(--base-grey);
        border-radius: 0px;
    }

    .blank-placeholder {
        min-height: 150px;
        background: #e1e1e1;
        border-radius: 0px;
    }

    .dashboard-column {
        padding: 0;
        margin-top: 4px;
    }

    .bg-placeholder {
        background: var(--base-grey-light);
        border-radius: 0px;
        width: 100%;
        height: 100%;
        min-height: 100px;
        padding: 15px;
    }

    .card-background-icon {
        opacity: 0.1;
        right: 0px;
        position: absolute;
        top: 10px;
        font-size: 250px;
    }

    .service-card {
        border-radius: 4px;
        padding: 20px;
        height: 100%;

        a {
            color: #ffffff;
            position: relative;
            z-index: 10;
            font-size: 14px;
        }

        &.reports-card {
            background-color: var(--dashboard-tile-color);
        }

        &.websites-card {
            background-color: var(--dashboard-tile-color);
        }

        &.emails-card {
            background-color: var(--dashboard-tile-color);
        }
    }
</style>
<style lang="scss">
    @import '../../sass/_variables.scss';

    .dashboard-home {
        .user-info {
            min-height: 220px !important;

            @media(max-width: 768px) {
                min-height: 170px !important;
            }
        }

        .progressive-background-slot {
            position: absolute !important;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 15px;

            * {
                position: relative;
            }

            &:before {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                opacity: .8 !important;
                transition: all 5s;
            }
        }

        .primary .progressive-background-slot:before {
            background-color: var(--primary-color);
        }

        .secondary .progressive-background-slot:before {
            background-color: var(--secondary-color);
        }

        .tertiary .progressive-background-slot:before {
            background-color: var(--tertiary-color);
        }

        .grey .progressive-background-slot:before {
            background-color: var(--base-grey-dark);
        }

        .notification {
            min-height: 170px;

            a:not(.button):not(.dropdown-item) {
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            .link-icon {
                margin-right: 5px;
            }
        }
    }

    .relative-top {
        position: relative;
        z-index: 15;
    }
</style>
